import { z } from "zod";
import { format } from "date-fns";

const optional = () => z.string().optional().or(z.literal(""));

export const vendorPaymentFormSchema = z.object({
  vendor_id: z.string().min(1, "Vendor is required"),
  purchase_order_id: optional(),
  payment_date: z.string().min(1),
  amount: z.coerce.number().positive("Amount must be greater than 0"),
  payment_method: z.enum(["cash", "upi", "card", "bank_transfer", "cheque", "other"]),
  reference: optional(),
  notes: optional(),
});

export type VendorPaymentFormValues = z.infer<typeof vendorPaymentFormSchema>;

export const emptyVendorPaymentForm: VendorPaymentFormValues = {
  vendor_id: "",
  purchase_order_id: "",
  payment_date: format(new Date(), "yyyy-MM-dd"),
  amount: 0,
  payment_method: "bank_transfer",
  reference: "",
  notes: "",
};
